<template>
  <base-edit></base-edit>
</template>

<script>
  import BaseEdit from './baseEdit';

  export default {
    name: 'businessReceiptAdd',
    components: {
      BaseEdit,
    },
  };
</script>
